import { DATA_ELEMENT_ID, DATA_PLACEHOLDER, TEMPLATE_FILE } from './constants';
import type { ExportPayload } from './types';

/** JSON so maskieren, dass es in einem <script>-Element nicht ausbrechen kann. */
function safeJson(value: unknown): string {
  return JSON.stringify(value)
    .replace(/</g, '\\u003c')
    .replace(/&/g, '\\u0026')
    .replace(new RegExp('\\u2028', 'g'), '\\u2028')
    .replace(new RegExp('\\u2029', 'g'), '\\u2029');
}

export function fillTemplate(template: string, payload: ExportPayload): string {
  const parts = template.split(DATA_PLACEHOLDER);
  if (parts.length !== 2) {
    throw new Error(
      `Die Clickdummy-Vorlage ist ungültig: Der Platzhalter kommt ${parts.length - 1}-mal vor, erwartet genau einmal. ` +
        'Wurde die Anwendung vollständig gebaut (pnpm build)?',
    );
  }
  const script = `<script type="application/json" id="${DATA_ELEMENT_ID}">${safeJson(payload)}</script>`;
  return parts[0] + script + parts[1];
}

export async function fetchTemplate(fetchImpl: typeof fetch = fetch): Promise<string> {
  const url = `${import.meta.env.BASE_URL}${TEMPLATE_FILE}`;
  const fail = (why: string) =>
    new Error(
      `Die Clickdummy-Vorlage konnte nicht geladen werden (${why}). ` +
        'Sie wird erst beim Produktions-Build erzeugt und fehlt z. B. im Dev-Server.',
    );
  let res: Response;
  try {
    res = await fetchImpl(url, { cache: 'no-store' });
  } catch {
    throw fail('Netzwerkfehler');
  }
  if (!res.ok) throw fail(`HTTP ${res.status}`);
  return res.text();
}

export function downloadHtml(html: string, filename: string): void {
  const url = URL.createObjectURL(new Blob([html], { type: 'text/html;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

const TRANSLIT: Record<string, string> = { ä: 'ae', ö: 'oe', ü: 'ue', ß: 'ss', Ä: 'ae', Ö: 'oe', Ü: 'ue' };

export function exportFilename(projectName: string, date: Date): string {
  const slug = projectName
    .replace(/[äöüßÄÖÜ]/g, (c) => TRANSLIT[c] ?? c)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40)
    .replace(/-+$/g, '');
  const pad = (n: number) => String(n).padStart(2, '0');
  const day = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  return `clickdummy-${slug || 'projekt'}-${day}.html`;
}
